module.exports = __webpack_public_path__ + "static/img/app2.328a281.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/app2.jpg
// module id = MQFm
// module chunks = 0